import React, { useEffect, useState } from "react"
import { Card, PopoverBody, UncontrolledPopover } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  downloadCOA,
  fetchFinanceChartOfAcc,
  getAccountLedger,
  getAccountLedgerCOA,
} from "../../../services/finance/finance"
import OpenArrowIcon from "../../../assets/icons/iconComponents/openArrow"
import CloseArrowIcon from "../../../assets/icons/iconComponents/closwArrow"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
// import 'bootstrap/dist/css/bootstrap.min.css';

// const financialData = [
//   {
//     category_name: "Assets",
//     account_groups: [
//       {
//         group_name: "Current Asset",
//         ledgers: [
//           { ledger_name: "Stock In Hand" },
//           { ledger_name: "Office Interior(WIP)" },
//         ],
//         sub_groups: [
//           {
//             group_name: "Bank Account",
//             ledgers: [
//               { ledger_name: "Bank Transfer" },
//               { ledger_name: "NBD Bank" },
//             ],
//             sub_groups: [],
//           },
//           {
//             group_name: "Cash-in-Hand",
//             ledgers: [{ ledger_name: "Petty Cash" }],
//             sub_groups: [],
//           },
//         ],
//       },
//     ],
//   },
//   {
//     category_name: "Liabilities",
//     account_groups: [
//       {
//         group_name: "Current Liabilities",
//         ledgers: [{ ledger_name: "Sundry Creditors" }],
//         sub_groups: [],
//       },
//     ],
//   },
//   {
//     category_name: "Income",
//     account_groups: [
//       {
//         group_name: "Sales",
//         ledgers: [{ ledger_name: "Product Sales" }],
//         sub_groups: [],
//       },
//     ],
//   },
//   {
//     category_name: "Expenses",
//     account_groups: [
//       {
//         group_name: "Operating Expenses",
//         ledgers: [{ ledger_name: "Rent" }, { ledger_name: "Utilities" }],
//         sub_groups: [],
//       },
//     ],
//   },
// ]

// const TreeNode = ({ name, group_id, children, level, defaultOpen = false, balanceText }) => {
//   const [isOpen, setIsOpen] = useState(defaultOpen)
//   const [leadgerData, setLeadgerData] = useState();
//   const toggle = () => setIsOpen(!isOpen)

//   const hasChildren = React.Children.count(children) > 0

//   const handleClick = async (data) => {
//     const response = await getAccountLedger(data)
//     setLeadgerData(response?.data)
//   }

//   return (
//     <div
//       className="position-relative"
//       style={{ paddingLeft: `${level * 20}px` }}
//     >
//       <div
//         onClick={(e) => {
//           if (hasChildren) {
//             toggle()
//           }
//           handleClick(group_id)
//         }}
//         className={`cursor-pointer d-flex align-items-center ${hasChildren ? "fw-500" : ""}`}
//       >
//         <span className="me-2" style={{ width: "10px" }}>
//           {hasChildren ? (isOpen ? <OpenArrowIcon /> : <CloseArrowIcon />) : "•"}
//         </span>
//         {name}
//         {balanceText && (
//           <span className="text-muted ms-2 w-100 d-flex justify-content-end">
//             {balanceText}
//           </span>
//         )}
//       </div>

//       {isOpen && hasChildren && (
//         <div className="ms-1 coa-border ps-1">{children}</div>
//       )}
//     </div>
//   )
// }

const TreeNode = ({
  name,
  group_id,
  children,
  level,
  defaultOpen = false,
  balanceText,
  onGroupClick,
  group,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const [ledgerData, setLedgerData] = useState([])
  const [showLedgers, setShowLedgers] = useState(false)
  const desimalrange = localStorage.getItem("desimalrange")


  console.log(`children`, group);
  

  const toggle = () => setIsOpen(!isOpen)
  const hasChildren = React.Children.count(children) > 0
  const hasChilds = group?.has_ledger || React.Children.count(children) > 0

  const handleClick = async data => {
    // Always call onGroupClick (even if accordion)
    if (onGroupClick && data) {
      onGroupClick(data)
    }

    // Accordion logic
    // if (hasChildren) {
    //   toggle()
    // }
    toggle()
    // // Load ledger data if not accordion
    if (data) {
      try {
        const response = await getAccountLedgerCOA(data)
        setLedgerData(response?.data || [])
        setShowLedgers(!showLedgers)
      } catch (error) {
        console.error("Error fetching ledger data:", error)
      }
    }
  }

  return (
    <div
      className="position-relative"
      style={{ paddingLeft: `${level * 20}px` }}
    >
      <div
        onClick={() => handleClick(group_id)}
        className={`cursor-pointer d-flex align-items-center ${
          hasChilds ? "fw-500" : ""
        }`}
      >
        <span className="me-2" style={{ width: "10px" }}>
          {hasChilds ? isOpen ? <OpenArrowIcon /> : <CloseArrowIcon /> : "•"}
        </span>
        {name}
        {/* {balanceText && (
          <span className="text-muted ms-2 w-100 d-flex justify-content-end">
            {balanceText}
          </span>
        )} */}
      </div>

      {isOpen && hasChildren && (
        <div className="ms-1 coa-border ps-1">{children}</div>
      )}

      {showLedgers && ledgerData.length > 0 && (
        <div
          className="ms-1 coa-border ps-1"
          style={{ paddingLeft: `${(level + 1) * 20}px` }}
        >
          {ledgerData.map(ledger => (
            <div key={ledger?.id} className="d-flex align-items-center">
              <span className="me-2 ms-3" style={{ width: "10px" }}>
                •
              </span>
              {ledger?.name}
              <span className="text-muted ms-2 w-100 d-flex justify-content-end">
                {getFormattedBalance(
                  ledger?.account_group?.parent_type?.name
                )}
                {/* {getFormattedBalance(
                  ledger?.account_group?.parent_type?.name,
                  Number(ledger?.closing_balance)
                )} */}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// Balance formatting helper
const getFormattedBalance = (category, closing_balance) => {
  if (closing_balance === undefined || closing_balance === null) return null

  const value = Number(closing_balance)
  const absValue = NumberFormat(Math.abs(value), 3, 3)

  let type
  if (category === "Assets" || category === "Expenses") {
    type = value >= 0 ? "Dr" : "Cr"
  } else {
    type = value >= 0 ? "Cr" : "Dr"
  }

  return `${absValue} ${type}`
}

// Recursive group rendering
const renderGroupTree = (group, level, category, handleGroup) => {
  return (
    <TreeNode
      key={group.group_id || group.group_name}
      name={group.group_name}
      group_id={group?.group_id}
      level={level}
      defaultOpen={false}
      balanceText={getFormattedBalance(category, group?.closing_balance)}
      onGroupClick={handleGroup}
      group={group}
    >
      {(group?.ledgers || []).map(ledger => (
        <TreeNode
          key={ledger.ledger_id || ledger.ledger_name}
          name={ledger.ledger_name}
          level={level + 1}
          defaultOpen={false}
          balanceText={getFormattedBalance(category, ledger?.closing_balance)}
          group={group}
        />
      ))}
      {(group?.sub_groups || []).map(subGroup =>
        renderGroupTree(subGroup, level + 1, category, handleGroup)
      )}
    </TreeNode>
  )
}

// Main DirectoryTree component
const DirectoryTree = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Chart Of Accounts${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;
  const [financialData, setFinancialData] = useState([])

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  useEffect(() => {
    const fetchFinancialData = async () => {
      try {
        const response = await fetchFinanceChartOfAcc()
        setFinancialData(response.data || [])
      } catch (error) {
        console.error("Error fetching financial data:", error)
      }
    }

    fetchFinancialData()
  }, [])

  const handleGroup = groupId => {
    console.log("Group clicked:", groupId)
    // Additional logic here (e.g., analytics, setting state, etc.)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Finance"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: crumb || "Reports", link: "/finance" },
                { title: "Chart Of Accounts", link: "/finance-chart-of-acc" },
              ]}
            />
            <>
            <div className="me-2">
              <span id={`PopoverLegacy-1`} className="px-2 mb-3 btn btn-primary">
                Download
              </span>
              
            </div>
            <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadCOA("pdf", "coa.pdf")
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadCOA("excel", "coa.xlsx")
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>

          <Card className="me-2 px-2 pb-2">
            <div className="p-3" style={{ whiteSpace: "pre" }}>
              {(financialData || []).map(category => (
                <TreeNode
                  key={category.category_id || category.category_name}
                  name={category.category_name}
                  level={0}
                  defaultOpen={false}
                >
                  {(category?.account_groups || []).map(group =>
                    renderGroupTree(
                      group,
                      1,
                      category.category_name,
                      handleGroup
                    )
                  )}
                </TreeNode>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default DirectoryTree
